import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import api from "../../constants/api.js";
import Modal from "../../components/modal/modal.jsx";
import Swal from "sweetalert2";
import "./midias_footer.css";

function MidiasFooterAdmin({ tipo }) {
  const { id_post, id_materia } = useParams();
  const id = tipo === "post" ? id_post : id_materia;

  const [midias, setMidias] = useState([]);
  const [img, setImg] = useState(null);
  const [loading, setLoading] = useState(true);
  const [open, setOpen] = useState(false);

  /* ================= BUSCAR ================= */
  useEffect(() => {
    async function fetchMidias() {
      try {
        const rota =
          tipo === "post"
            ? `/posts/${id}/midias-footer`
            : `/materias/${id}/midias-footer`;

        const res = await api.get(rota);
        setMidias(res.data || []);
      } catch {
        console.log("Erro ao buscar mídias");
      } finally {
        setLoading(false);
      }
    }

    fetchMidias();
  }, [id, tipo]);

  /* ================= ADICIONAR ================= */
  async function adicionarMidia() {
    if (!img) throw new Error("Selecione uma imagem");

    const formData = new FormData();
    formData.append("imagem", img);

    if (tipo === "post") formData.append("id_post", id);
    if (tipo === "materia") formData.append("id_materia", id);

    const res = await api.post("/midias-footer", formData);
    setMidias(prev => [...prev, res.data]);
    setImg(null);
  }

  /* ================= EXCLUIR ================= */
  async function excluirMidia(id_midia) {
  const confirm = await Swal.fire({
    title: "Tem certeza?",
    text: "Essa imagem será excluída permanentemente.",
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: "Sim, excluir",
    cancelButtonText: "Cancelar",
    confirmButtonColor: "#e53935",
    cancelButtonColor: "#64748b"
  });

  if (!confirm.isConfirmed) return;

  try {
    await api.delete(`/midias-footer/${id_midia}`);

    setMidias(prev =>
      prev.filter(m => m.id_midia !== id_midia)
    );

    Swal.fire({
      icon: "success",
      title: "Imagem excluída!",
      timer: 1200,
      showConfirmButton: false
    });
  } catch (error) {
    Swal.fire(
      "Erro",
      error.response?.data?.error || "Erro ao excluir imagem",
      "error"
    );
  }
}


  if (loading) return <p>Carregando mídias...</p>;

  return (
    <section className="mf-wrapper">
      <header className="mf-header">
        <h2 className="mf-title">
          Mídias do {tipo === "post" ? "Post" : "Matéria"}
        </h2>

        <button className="mf-btn-add" onClick={() => setOpen(true)}>
          + Adicionar imagem
        </button>
      </header>

      <div className="mf-grid">
        {midias.map(m => (
          <div className="mf-card" key={m.id_midia}>
            <img src={m.imagem_url} alt="midia" />
            <button
              className="mf-btn-delete"
              onClick={() => excluirMidia(m.id_midia)}
            >
              Excluir
            </button>
          </div>
        ))}
      </div>

      <Modal
        isOpen={open}
        setOpen={setOpen}
        enviar={adicionarMidia}
        tipo="banner"
        img={img}
        setImg={setImg}
      />
    </section>
  );
}

export default MidiasFooterAdmin;
